<script setup lang="js">
import {ref} from "vue";
import ContextColors from "@/components/ContextColors.vue";
import Context from "@/components/Context.vue";
const gsjj = ref('https://cos5.51tgqj.com/techming/img/gsjj@2x.png')
const jjpt1 = ref('https://cos5.51tgqj.com/techming/img/jjpt1@2x.png')
const jjpt2 = ref('https://cos5.51tgqj.com/techming/img/jjpt2@2x.png')
const jjpt3 = ref('https://cos5.51tgqj.com/techming/img/jjpt3@2x.png')
const jjpt4 = ref('https://cos5.51tgqj.com/techming/img/jjpt4@2x.png')
const fzlc = ref('https://cos5.51tgqj.com/techming/img/fzlc@2x.png')
const lcmj = ref('https://cos5.51tgqj.com/techming/img/lcmj@2x.png')
const lctg = ref('https://cos5.51tgqj.com/techming/img/lctg@2x.png')
const lctt = ref('https://cos5.51tgqj.com/techming/img/lctt@2x.png')
const lcsx = ref('https://cos5.51tgqj.com/techming/img/lcsx@2x.png')
const lchbm = ref('https://cos5.51tgqj.com/techming/img/lchbm@2x.png')
const lcws = ref('https://cos5.51tgqj.com/techming/img/lcws@2x.png')
const lccyp = ref('https://cos5.51tgqj.com/techming/img/lccyp@2x.png')
const lcry = ref('https://cos5.51tgqj.com/techming/img/lcry@2x.png')
const lcqf = ref('https://cos5.51tgqj.com/techming/img/lcqf@2x.png')
const lccf = ref('https://cos5.51tgqj.com/techming/img/lccf@2x.png')
const lcjl = ref('https://cos5.51tgqj.com/techming/img/lcjl@2x.png')
const lcczj = ref('https://cos5.51tgqj.com/techming/img/lcczj@2x.png')
const lcgz = ref('https://cos5.51tgqj.com/techming/img/lcgz@2x.png')
const lczjtx = ref('https://cos5.51tgqj.com/techming/img/lczjtx@2x.png')
const zzry = ref('https://cos5.51tgqj.com/techming/img/zzry@2x.png')
const jb = ref('https://cos5.51tgqj.com/techming/img/jb@2x.png')
const rzfree = ref('https://cos5.51tgqj.com/techming/img/rzfree.jpg')
const rzOne = ref('https://cos5.51tgqj.com/techming/img/rzOne.jpg')
const rzTwo = ref('https://cos5.51tgqj.com/techming/img/rzTwo.jpg')
const rz4 = ref('https://cos5.51tgqj.com/techming/img/rz4.jpg')
const rz5 = ref('https://cos5.51tgqj.com/techming/img/rz5.jpg')
const rz6 = ref('https://cos5.51tgqj.com/techming/img/rz6.png')
const rz7_Page1_Image1 = ref('https://cos5.51tgqj.com/techming/img/rz7_Page1_Image1.jpg')
const rz8_Page1_Image1 = ref('https://cos5.51tgqj.com/techming/img/rz8_Page1_Image1.jpg')
const rz9_Page1_Image1 = ref('https://cos5.51tgqj.com/techming/img/rz9_Page1_Image1.jpg')


</script>

<template>
  <div>
    <context-colors color="bg-[#ffffff]">
      <div class="w-full flex justify-center">
        <el-image :src="gsjj" class="h-[3.88rem]"/>
      </div>

      <div class="flex justify-between mt-6">
        <div class="basis-1/6 md:basis-1/6  lg:basis-1/12 flex flex-col justify-center">
          <el-image :src="jjpt1" class="w-full"/>
        </div>
        <div class="basis-5/6 md:basis-5/6  lg:basis-11/12 flex flex-col justify-center ml-4">
          <text class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-left">
            　　重庆铭匠网络科技有限公司是数智化人力资源服务品牌建设与运营商，以“智邻职创生态圈”为核心战略，聚焦“家门口就业创业”，通过“品牌IP+数智平台+区域闭环”三位一体服务体系，推动基层人力资源服务革新。公司依托复合型专业团队和政企协同机制，累计服务超20万求职者、1000余家企业，助力区域经济高质量发展。
          </text>
        </div>
      </div>
      <div class="flex justify-between mt-6">
        <div class="basis-5/6 md:basis-5/6  lg:basis-11/12 flex flex-col justify-center">
          <text class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-right">
            　　　　首创“IP+数据双轮驱动”模式，为区县定制“前锋直聘”“川渝聘”等区域化就业品牌IP，打造“一地一策”服务生态。通过动态人才热力地图、AI智能匹配算法实现精准人岗对接，匹配效率较行业提升25%，人岗对接周期缩短66%。构建“15分钟就业服务环”，线下覆盖200余个社区，线上融合直播带岗、零工经济等场景，基层服务触达率提升至98%。旗下“武胜智聘”获四川省政务新媒体案例第一，“前锋直聘”获人社部门调研推广，形成可复制的区域服务标杆。
          </text>
        </div>
        <div class="basis-1/6 md:basis-1/6  lg:basis-1/12  flex flex-col items-end ml-4 ">
          <el-image :src="jjpt2" class="w-full"/>
        </div>
      </div>
      <div class="flex justify-between mt-6">
        <div class="basis-1/6 md:basis-1/6  lg:basis-1/12 flex flex-col justify-center ml-4 ">
          <el-image :src="jjpt3" class="w-full"/>
        </div>
        <div class="basis-5/6 md:basis-5/6  lg:basis-11/12 flex flex-col justify-center  ml-4">
          <text class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-left">
            　　　　企业侧：数智化平台助力企业招聘效率提升40%，用工成本降低30%，川渝高竹新区入驻企业用工规模年增30%；　　政府侧：节约公共服务成本20%，基层服务覆盖率从50%提升至98%，有效解决“最后一公里”服务难题；　　民生侧：数智平台AI求职助手提供7×24小时智能服务，精准推送岗位，累计帮助3万余人实现“家门口”就业，其中农村劳动力占比60%，残疾人、退役军人等重点群体占比20%。通过“招岗喵”等平台串联社区资源，孵化手工艺、家政服务等轻资产创业项目，激活社区经济内生动力。
          </text>
        </div>
      </div>

      <div class="flex justify-between mt-6">
        <div class="basis-5/6 md:basis-5/6  lg:basis-11/12 flex flex-col justify-center">
          <text class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-right">
            　　　　　　以数智化手段消除就业壁垒，推动偏远地区就业率提升35%。建设广安首个数智人力资源市场、微创园等基础设施，联动社区开展电商运营、新媒体技能培训，提升居民数字化就业能力。通过“社区创业工坊”模式，链接小微供应链与本地需求，实现“就业不离家、创业在街坊”的可持续发展路径。　　公司秉持“码上家门口，职创全都有”理念，以川渝聘、招岗喵等多个平台构建全链条服务生态，持续以“有温度的数智化”重塑就业创业服务格局，为川渝协同发展注入创新动能。
          </text>
        </div>
        <div class="basis-1/6 md:basis-1/6  lg:basis-1/12 flex flex-col items-end ml-4">
          <el-image :src="jjpt4" class="w-full"/>
        </div>
      </div>
    </context-colors>

    <context>
      <div class="w-full flex justify-center">
        <el-image :src="fzlc" class="h-[3.88rem]"/>
      </div>
      <div>
        <div class="my-20 ">
          <div class="w-full  border-s border-[#011A81] flex relative ">
            <div class="w-full bg-white h-1 absolute translate-y-1/2 top-16"></div>
            <div class="w-full flex  justify-between mt-2 text-white text-[2rem] overflow-x-auto">
              <div class="z-50" >
                <div class="text-[#011A81]">&nbsp;</div>
                <div class="w-[1.8rem] h-[1.8rem] rounded-full border border-white bg-[#011A81] "></div>
              </div>
              <div class="" >
                <div class="flex flex-col justify-center items-center ">
                  <div>2017</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcmj" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">铭匠成立</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div class="line-clamp-1">2018-2020</div>
                  <div class="w-[1.6rem] h-[1.6rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lctg" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">天工巧匠APP社区工匠模式</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div>2021</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lctt" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">春风行动——数字岗位展广安首个数字化平台及人力资源市场天工巧匠农民工就业大数据</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div>2022</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcsx" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">邻水县公共实训基地</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lchbm" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">广安招聘IP广小招安小聘</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div>2023</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcws" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">武胜智聘</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lccyp" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">川渝高竹新区数智零工市场川渝聘平台</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcry" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28 ">重庆市首届人资服务创新创业大赛优胜奖</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div>2024</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcqf" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">前锋直聘“一站四员”</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lccf" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28 text-center">睦春风</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcjl" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28 text-center">就在九龙</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <text class="text-[1.13rem] mt-2 w-44">广安市系列数智招聘会广安市白塔微创园邻水县青创园邻水县数智零工市场重庆仙桃噪音预警系统</text>
                </div>
              </div>
              <div class="">
                <div class="flex flex-col justify-center items-center ">
                  <div>2023</div>
                  <div class="w-[1.69rem] h-[1.69rem] rounded-full bg-white text-center"></div>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcczj" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">创在家门口</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lcgz" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28">川渝高竹新区智慧维权系统</text>
                </div>
                <div class="flex  flex-col mt-4  justify-center items-center">
                  <el-image :src="lczjtx" class="w-12 h-12"/>
                  <text class="text-[1.13rem] mt-2 w-28 ">专精特新广安市系列数智招聘会</text>
                </div>
              </div>
              <div class="z-50" >
                <div class="text-[#011A81]">&nbsp;</div>
                <div class="w-0 h-0 border-solid border-t-transparent border-l-transparent border-b-transparent border-[1rem] rotate-180  absolute inset-y-0 -right-5 top-14"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </context>
    <context-colors color="bg-[#fff]">
      <div class="w-full flex justify-center">
        <el-image :src="zzry" class="h-[3.88rem]"/>
      </div>
      <div class="lg:flex justify-center text-center my-8">
        <div class="lg:basis-3/12 text-center flex justify-center">
          <el-image :src="jb" class="w-1/3 md:w-1/3 lg:w-full"/>
        </div>
        <div class="basis-3/5">
          <el-carousel interval="8000" type="card">
            <el-carousel-item >
              <el-image :src="rzfree" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rzOne" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rzTwo" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz4" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz5" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz6" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz9_Page1_Image1" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz7_Page1_Image1" class="h-full"/>
            </el-carousel-item>
            <el-carousel-item >
              <el-image :src="rz8_Page1_Image1" class="h-full"/>
            </el-carousel-item>
          </el-carousel>


        </div>
      </div>
    </context-colors>


  </div>
</template>

<style scoped>

</style>
